import React from 'react';

const Logo = () => {
    return (
        <svg width={46.503} height={41.3} viewBox="0 0 46.503 41.3">
            <g data-name="Group 227">
                <g data-name="Group 4">
                    <g data-name="Group 3">
                        <g data-name="Group 1">
                            <path
                                data-name="Path 2"
                                d="M14.62 34.279l8.33-8.33a.9.9 0 000-1.264l-3.763-3.763a.9.9 0 00-1.264 0l-3.3 3.3a.9.9 0 01-1.264 0l-3.073-3.073a.9.9 0 010-1.264L27.43 2.743a.876.876 0 00-.086-1.321 7.1 7.1 0 00-9.278.661L4.681 15.525l-.029-.029-4.395 4.395a.9.9 0 000 1.264"
                                fill="#fff"
                            />
                        </g>
                        <g data-name="Group 2">
                            <path
                                data-name="Path 3"
                                d="M33.146 17.103l3.073 3.073a.9.9 0 010 1.264L19.043 38.559a.876.876 0 00.086 1.321 7.1 7.1 0 009.278-.661l13.414-13.414.029.029 4.395-4.395a.9.9 0 000-1.264L33.119 7.049a.9.9 0 00-1.264 0l-8.33 8.33a.9.9 0 000 1.264l3.763 3.763a.9.9 0 001.264 0l3.3-3.3a.936.936 0 011.294-.003z"
                                fill="#fff"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Logo;
